/** The signing site's words (namespace `sign`); the documents' own come from `@tnn/domain` */
export const th = {
  sentBy: '{{company}} ส่งเอกสารถึงคุณ',
  amount: 'ยอด {{amount}} บาท',
  due: 'ครบกำหนด {{date}}',
  signTitle: 'เซ็นรับเอกสาร',
  signHint: 'ตรวจเอกสารด้านบน แล้วลงชื่อรับ ไม่ต้องสมัครหรือเข้าสู่ระบบ',
  name: 'ชื่อ-นามสกุลผู้รับ',
  title: 'ตำแหน่ง',
  legal: 'การลงลายมือชื่อนี้เป็นลายมือชื่ออิเล็กทรอนิกส์ตาม พ.ร.บ.ว่าด้วยธุรกรรมทางอิเล็กทรอนิกส์ ระบบเก็บเวลาและเครื่องที่ใช้เซ็นไว้เป็นหลักฐาน',
  submit: 'เซ็นรับเอกสาร',
  needSignature: 'กรุณาเซ็นชื่อในกรอบ',
  signed: 'เซ็นรับเรียบร้อย',
  signedBy: '{{name}} · {{at}}',
  keep: 'เก็บเอกสารไว้ได้ ลิงก์นี้เปิดได้ถึง {{date}}',
  download: 'ดาวน์โหลด PDF',
  print: 'พิมพ์',
  making: 'กำลังทำไฟล์ PDF…',
  toSign: 'ไปที่ช่องเซ็น',
  invalid: 'ลิงก์นี้ใช้ไม่ได้',
  invalidHint: 'อาจถูกยกเลิกหรือพิมพ์ไม่ครบ ติดต่อผู้ส่งเพื่อขอลิงก์ใหม่',
  expired: 'ลิงก์นี้หมดอายุแล้ว',
  expiredHint: 'ติดต่อผู้ส่งเพื่อขอลิงก์ใหม่',
  failed: 'โหลดเอกสารไม่สำเร็จ ลองใหม่อีกครั้ง',
  unsigned: 'ยังไม่ได้เซ็น',
  /** A bill's sender accepting its shipping terms */
  terms: {
    full: 'อ่านฉบับเต็ม',
    hide: 'ซ่อนฉบับเต็ม',
    signTitle: 'เซ็นยอมรับเงื่อนไขการขนส่ง',
    signHint: 'อ่านเงื่อนไขด้านบน ติ๊กยอมรับ แล้วลงชื่อ ไม่ต้องสมัครหรือเข้าสู่ระบบ',
    name: 'ชื่อ-นามสกุลผู้ส่ง หรือผู้เซ็นแทน',
    needAccept: 'ติ๊กว่าอ่านและยอมรับเงื่อนไขแล้ว',
    submit: 'ยอมรับและเซ็น',
    signed: 'เซ็นยอมรับเงื่อนไขเรียบร้อย',
  },
  /** A company that paid a bill issuing the receipt in its name (`/receipt/<code>/<payment>`) */
  receipt: {
    title: 'ใบเสร็จรับเงินในนามนิติบุคคล',
    bill: 'บิล {{number}}',
    paid: 'ชำระ {{amount}} บาท',
    paidAt: 'เมื่อ {{date}} ที่สาขา{{branch}}',
    formTitle: 'ข้อมูลบนใบเสร็จ',
    formHint: 'ใส่ชื่อและที่อยู่ตามที่จดทะเบียน ใบนี้ออกแทนใบเสร็จที่ได้รับตอนชำระ ยอดเงินเท่าเดิม',
    name: 'ชื่อนิติบุคคล',
    namePlaceholder: 'เช่น บริษัท ตัวอย่าง จำกัด',
    taxId: 'เลขประจำตัวผู้เสียภาษี 13 หลัก',
    headOffice: 'สำนักงานใหญ่',
    branch: 'สาขา',
    branchNo: 'เลขที่สาขา 5 หลัก',
    address: 'ที่อยู่ (เลขที่ อาคาร ถนน)',
    until: 'ขอเองได้ถึง {{date}}',
    person: 'บุคคลธรรมดาที่ต้องการใบเสร็จในชื่อตัวเอง ติดต่อสาขาที่รับเงิน',
    review: 'ดูตัวอย่าง',
    reviewTitle: 'ตรวจใบเสร็จก่อนออก',
    reviewHint: 'ออกแล้วแก้เองไม่ได้ ถ้าผิดต้องให้สาขายกเลิกก่อนจึงออกใหม่ได้',
    confirm: '{{name}} เป็นผู้ชำระค่าขนส่งนี้ และข้อมูลบนใบเสร็จถูกต้อง',
    needConfirm: 'ติ๊กยืนยันก่อนออกใบเสร็จ',
    edit: 'แก้ไข',
    issue: 'ออกใบเสร็จ',
    issued: 'ออกใบเสร็จแล้ว',
    number: 'เลขที่ {{number}}',
    keep: 'สแกน QR บนบิลอีกครั้งเพื่อดาวน์โหลดใบนี้ได้ทุกเมื่อ',
    legal: 'ไม่ใช่ใบกำกับภาษี เพราะค่าขนส่งในประเทศยกเว้นภาษีมูลค่าเพิ่ม',
    elsewhere: 'ใบเสร็จนี้ออกในชื่อลูกค้าแล้ว',
    elsewhereHint: 'เลขที่ {{number}} ขอสำเนาได้ที่สาขาที่รับเงิน',
    expired: 'เลยเวลาขอใบเสร็จเองแล้ว',
    expiredHint: 'ขอเองได้ภายใน 30 วันหลังชำระ (ถึง {{date}}) ติดต่อสาขาที่รับเงินเพื่อขอใบเสร็จ',
    office: 'ใบเสร็จนี้ขอที่สาขา',
    officeHint: 'ติดต่อสาขาที่รับเงินเพื่อขอใบเสร็จในนามนิติบุคคล',
    call: 'โทรสาขา{{branch}}',
    missing: 'ไม่พบการชำระเงินนี้',
    missingHint: 'เปิดจากหน้าติดตามพัสดุของบิลอีกครั้ง',
    back: 'กลับไปหน้าติดตามพัสดุ',
  },
}

export const en: typeof th = {
  sentBy: '{{company}} sent you a document',
  amount: '{{amount}} baht',
  due: 'Due {{date}}',
  signTitle: 'Sign to receive it',
  signHint: 'Check the document above, then sign for it: no account or sign-in needed',
  name: 'Your full name',
  title: 'Title',
  legal:
    'This is an electronic signature under Thailand’s Electronic Transactions Act: the time and device it is signed on are kept as evidence',
  submit: 'Sign to receive',
  needSignature: 'Please sign in the box',
  signed: 'Signed for',
  signedBy: '{{name}} · {{at}}',
  keep: 'Keep the document: this link opens until {{date}}',
  download: 'Download PDF',
  print: 'Print',
  making: 'Making the PDF…',
  toSign: 'Go to sign',
  invalid: 'This link does not work',
  invalidHint: 'It may have been withdrawn or not copied in full: ask the sender for a new one',
  expired: 'This link has expired',
  expiredHint: 'Ask the sender for a new one',
  failed: 'The document did not load: try again',
  unsigned: 'Not signed yet',
  terms: {
    full: 'Read the full text',
    hide: 'Hide the full text',
    signTitle: 'Accept the shipping terms',
    signHint: 'Read the terms above, tick that you accept them, then sign: no account or sign-in needed',
    name: 'Full name of the sender, or whoever signs for them',
    needAccept: 'Tick that you have read and accept the terms',
    submit: 'Accept and sign',
    signed: 'Terms accepted',
  },
  receipt: {
    title: 'Receipt in a company’s name',
    bill: 'Waybill {{number}}',
    paid: 'Paid {{amount}} baht',
    paidAt: 'on {{date}} at {{branch}} branch',
    formTitle: 'On the receipt',
    formHint: 'Its registered name and address. It replaces the receipt given when you paid, for the same money',
    name: 'Company name',
    namePlaceholder: 'e.g. Example Co., Ltd.',
    taxId: '13-digit tax ID',
    headOffice: 'Head office',
    branch: 'Branch',
    branchNo: '5-digit branch number',
    address: 'Address (number, building, road)',
    until: 'You can issue it here until {{date}}',
    person: 'For a receipt in a person’s name, ask the branch that took the money',
    review: 'Preview',
    reviewTitle: 'Check the receipt before issuing it',
    reviewHint: 'Once issued you cannot change it: the branch has to cancel it before another is issued',
    confirm: '{{name}} paid this freight and the details on the receipt are right',
    needConfirm: 'Tick to confirm before issuing it',
    edit: 'Edit',
    issue: 'Issue the receipt',
    issued: 'Receipt issued',
    number: 'No. {{number}}',
    keep: 'Scan the QR on the waybill again to download it any time',
    legal: 'Not a tax invoice: domestic freight is exempt from VAT',
    elsewhere: 'A receipt in the customer’s name was issued for this',
    elsewhereHint: 'No. {{number}}: ask the branch that took the money for a copy',
    expired: 'Too late to issue it here',
    expiredHint: 'It can be issued here within 30 days of paying (until {{date}}): ask the branch that took the money',
    office: 'The branch issues this one',
    officeHint: 'Ask the branch that took the money for a receipt in your company’s name',
    call: 'Call {{branch}} branch',
    missing: 'This payment was not found',
    missingHint: 'Open it again from the waybill’s tracking page',
    back: 'Back to tracking',
  },
}
